/**
 * Sentinel PersonId used by the backend for automated / system-initiated actions
 * (not a real person). Do not call the Person API for this id.
 */
export const TREASURY_SYSTEM_PERSON_ID =
  '10000000-0000-0000-0000-000000000000';

export const TREASURY_SYSTEM_PERSON_DISPLAY_NAME = 'Sistema';

export const isTreasurySystemPersonId = (
  value: string | null | undefined,
): boolean =>
  (value ?? '').trim().toLowerCase() === TREASURY_SYSTEM_PERSON_ID;

/**
 * Movement list chip: `{CardBrand} **** {last4}` (e.g. `Visa **** 3945`), or `**** {last4}` when brand is absent.
 */
export const treasuryCardListSummary = (
  cardBrand: string | null | undefined,
  cardNumber: string | null | undefined,
): string | null => {
  const digits = (cardNumber ?? '').replace(/\D/g, '');
  if (digits.length < 4) {
    return null;
  }
  const lastFour = digits.slice(-4);
  const brand = (cardBrand ?? '').trim();
  return brand.length > 0 ? `${brand} **** ${lastFour}` : `**** ${lastFour}`;
};
